import QutoRelease from './QutoRelease';
import GameCompare from './GameCompare';


const teaserComponentMap = {
  quto_car_release: QutoRelease,
  game_compare: GameCompare,
  pair_compare: GameCompare,
};

export default function smartTeaser(block, parentProps) {
  const { teaser_type: teaserType } = block.attributes;
  const TeaserComponent = teaserComponentMap[teaserType] || null;

  return TeaserComponent ? (
    <TeaserComponent block={block} parentProps={parentProps} />
  ) : null;
}
